module.exports = __webpack_public_path__ + "img/logout.0855f71f.svg";